import { NavLink } from "react-router-dom";

function HomePage() {
  return (
    <>
      <section className="hero is-medium has-text-centered">
        <div className="hero-body">
          <div className="container">
            <div className="block">
              <img src="/logo192.png" alt="logo" width="128" height="128" />
            </div>
            <div className="block">
              <h1 className="title is-1 mb-3">
                EHS Consulting and Compliance. Fast.
              </h1>
            </div>
            <div className="block">
              <p className="subtitle is-4 mt-1">
                WVPP, HazCom/SDS, Heat & AQI, and OSHA e-Recordkeeping. Built
                for manufacturing, construction, and healthcare.
              </p>
            </div>
            <div className="block">
              <div className="content">
                <ul className="is-inline-block has-text-left is-size-5">
                  <li>Write and implement compliant programs</li>
                  <li>Train crews and track completion</li>
                  <li>Capture incidents and submit clean records</li>
                </ul>
              </div>
            </div>
            <div className="block">
              <div className="buttons is-centered">
                <NavLink to="/contact" className="button is-primary is-large">
                  Book a 20-minute consult
                </NavLink>
                <a
                  href="https://docs.google.com/forms/d/e/1FAIpQLSdaS08zOAsihujHodIFs33hvFzWVKIn_-08nWiR7WpdEQHtBQ/viewform?usp=sharing&ouid=106739976704729196293"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="button is-info is-large"
                >
                  Download the WVPP checklist
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="hero is-medium has-text-centered">
        <div className="hero-body">
          <div className="container">
            <div className="block">
              <h2 className="title is-2 mb-2">EHS Solutions</h2>
            </div>
            <div className="block">
              <p className="subtitle is-4">
                Take Control of Your Workplace EHS
              </p>
            </div>
            <div className="columns is-variable is-6">
              <div className="column is-4">
                <img
                  src="/images/homepage/Manufacturing.png"
                  alt="logo"
                  width="196"
                  height="294"
                  style={{ borderRadius: "100px" }}
                />
                <p className="subtitle is-5 has-text-weight-bold mt-3">
                  Logistics and Warehousing
                </p>
                <p>
                  IIPP and incident reporting that reduces risk. Forklift/PIT
                  compliance, ergonomics, and OSHA 300/301-ready logs.
                </p>
              </div>
              <div className="column is-4">
                <img
                  src="/images/homepage/construction.png"
                  alt="logo"
                  width="196"
                  height="294"
                  style={{ borderRadius: "100px" }}
                />
                <p className="subtitle is-5 has-text-weight-bold mt-3">
                  Outdoor Workplaces
                </p>
                <p>
                  Heat and AQI programs. Mobile inspections, toolbox talks, and
                  supervisor training with documented compliance.
                </p>
              </div>
              <div className="column is-4">
                <img
                  src="/images/homepage/healthcare.png"
                  alt="logo"
                  width="196"
                  height="294"
                  style={{ borderRadius: "100px" }}
                />
                <p className="subtitle is-5 has-text-weight-bold mt-3">
                  Education and Clinics
                </p>
                <p>
                  WVPP plans, training, and incident logs for schools, clinics,
                  and outreach programs. Privacy-safe reporting, training
                  completion tracking.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section has-background-light">
        <div className="container">
          <div className="has-text-centered mb-6">
            <h2 className="title is-3 mb-3" style={{ lineHeight: "1.3" }}>
              Current Regulatory Updates
            </h2>
            <p className="subtitle is-5" style={{ lineHeight: "1.4" }}>
              Stay compliant with the latest requirements
            </p>
          </div>
          <div className="columns is-multiline is-variable is-6">
            <div className="column is-12-mobile is-6-tablet is-4-desktop">
              <div
                className="box has-text-centered p-5"
                style={{ minHeight: "200px", wordBreak: "break-word" }}
              >
                <div className="content">
                  <h3 className="title is-4 has-text-primary">
                    CA WVPP (SB 553)
                  </h3>
                  <p className="subtitle is-6 has-text-grey-dark">
                    Effective July 1, 2024
                  </p>
                  <p className="is-size-6">
                    Workplace Violence Prevention Program
                  </p>
                </div>
              </div>
            </div>
            <div className="column is-12-mobile is-6-tablet is-4-desktop">
              <div
                className="box has-text-centered p-5"
                style={{ minHeight: "200px", wordBreak: "break-word" }}
              >
                <div className="content">
                  <h3 className="title is-4 has-text-primary">HazCom 2024</h3>
                  <p className="subtitle is-6 has-text-grey-dark">
                    Effective July 19, 2024
                  </p>
                  <p className="is-size-6">Aligned to GHS Rev. 7</p>
                </div>
              </div>
            </div>
            <div className="column is-12-mobile is-6-tablet is-4-desktop">
              <div
                className="box has-text-centered p-5"
                style={{ minHeight: "200px", wordBreak: "break-word" }}
              >
                <div className="content">
                  <h3 className="title is-4 has-text-primary">
                    Electronic Recordkeeping
                  </h3>
                  <p className="subtitle is-6 has-text-grey-dark">
                    OSHA Requirement
                  </p>
                  <p className="is-size-6">
                    100+ EEs in high-hazard industries must submit 300/301
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default HomePage;